/** Seitenübergreifend; nur hier ergänzen, was wirklich mehrere Seiten brauchen. */
export default {
  sport: {
    run: 'Laufen',
    ride: 'Rad',
    swim: 'Schwimmen',
    yoga: 'Yoga',
    strength: 'Kraft',
    hike: 'Wandern',
    walk: 'Gehen',
    other: 'Sonstiges',
  },
  comingWith: 'Kommt mit {milestone}.',
  loading: 'Lädt …',
  howCalculated: 'Wie berechnet?',
  retry: 'Nochmal versuchen',
  loadFailed: 'Konnte nicht geladen werden: {error}',
  save: 'Speichern',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  close: 'Schließen',
  back: 'Zurück',
  all: 'Alle',
  activities: { one: '{count} Aktivität', other: '{count} Aktivitäten' },
  days: { one: '{count} Tag', other: '{count} Tage' },
  weeks: { one: '{count} Woche', other: '{count} Wochen' },
};
